import { environment } from "src/environments/environment";

export const GlobalComponent = {
  // Api Calling
  API_URL: 'https://api-node.themesbrand.website/',
  // Auth Api
  AUTH_API: "https://api-node.themesbrand.website/auth/",

  // Products Api
  product: 'apps/product',
  productDelete: 'apps/product/',
  // Orders Api
  order: 'apps/order',
  orderId: 'apps/order/',
  // Customers Api
  customer: 'apps/customer',

  //LandingPageRouting
  landingPage: 'marketplace/marketplace',
  //LandingPageRouting
  explorePage: 'marketplace/explore',
  //landingPage: '', //dashboard analytics

  title: "MyFile",

  taxValue: 0.13,

  inviteCodeRequired: true,

  stringPattern: { pattern: new RegExp('[a-zA-Z0-9\'\&\.\,\-\s]{1,255}') },

  FILTER_PAG_REGEX: /[^0-9]/g,

  defaultToasterOptions: {
    progressBar: true,
    timeOut: 10000,
    closeButton: true,
    //positionClass: "toast-bottom-right"
  },

  defaultTagList: [
    "_knowledgebase",
    "realeasenotes",
    "howto",
    "faq"
  ],

  defaultSystemOcrTag: "_ocr",
  defaultSystemIsVectorizedTag: "_isVectorized",

  //Validation 
  emailPattern: new RegExp(/^(([^<>()\[\]\\.,;:\s@$"]+(\.[^<>()\[\]\\.,;:\s@$"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),

  //regex from: https://regex101.com/library/PEtM4r?filterFlavors=javascript&orderBy=RELEVANCE&page=2&search=email 
  datePattern: new RegExp(/^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/),

  defaultPagingInfo: {
    pageSize: 10,
    pageSizeLG: 25,
    pageSizeXL: 50,
    exportPageSize: 1000,
    maximumSearchDepth: 999999
  },

  minSearchLengthTerm: 2,

  defaultDocumentImageUrl: environment.staticImageApiUrl + "myfile_border.jpg",
  defaultMyFileImageDark: "",
  defaultMyFileImageWhite: "",
  defaultSessionInactivityTimeS: 60 * 240,

  lastActiveTime: 2 * 60000, // 60000ms is 1 min, used for the is online bubble. 

  /**
  * Converts server date to Javascript date.
  * @param inputDate the date as a string
  * @param convert boolean? True = converts to UTC, : False = converts to format: DD/MM/YYYY
  * @returns search result
  */
  dateTransform(inputDate: String, convert: Boolean) {
    var str: string[];
    if (convert) {
      str = inputDate.split('/');
      return str[2] + '-' + str[1] + '-' + str[0] + 'T00:00:00Z';
    } else {
      str = inputDate.split('-');
      inputDate = '/' + str[1] + '/' + str[0]
      str = str[2].split('T');
      return str[0] + inputDate;
    }
  },

  dateIsNotInFuture(date: string): boolean {
    var today = new Date();
    if (parseInt(date.substring(6, 10)) < today.getFullYear()) {
      return true;
    } else {
      if ((parseInt(date.substring(3, 5)) - 1) < today.getMonth()) {
        return true
      } else {
        if (parseInt(date.substring(0, 2)) <= today.getDate()) {
          return true
        }
      }
    }
    return false
  },

  ellipsesString(string: string | undefined, maxLength: number): string {
    if (string && string.length > maxLength) {
      string = string.substring(0, maxLength);
      return `${string}...`;
    }
    return `${string}`;
  },

  stripeFeeCalculation(amount: number): number{
    return amount*0.029+0.3;
  },

  statusList: [
    $localize`:@@List_Status_All:All`,
    $localize`:@@List_Status_Approved:Approved`,
    $localize`:@@List_Status_Disabled:Disabled`,
    $localize`:@@List_Status_Onboarding:Onboarding`,
    $localize`:@@List_Status_Pending:Pending`,
    $localize`:@@List_Status_PasswordReset:Password Reset`,
  ],

  provinceList: [
    { value: $localize`:@@List_Provinces_Alberta:Alberta`, selectedText: $localize`:@@List_Provinces_Alberta:Alberta`, dropdownText: $localize`:@@List_Provinces_Alberta:Alberta` },
    { value: $localize`:@@List_Provinces_BritishColumbia:British Columbia`, selectedText: $localize`:@@List_Provinces_BritishColumbia:British Columbia`, dropdownText: $localize`:@@List_Provinces_BritishColumbia:British Columbia` },
    { value: $localize`:@@List_Provinces_Manitoba:Manitoba`, selectedText: $localize`:@@List_Provinces_Manitoba:Manitoba`, dropdownText: $localize`:@@List_Provinces_Manitoba:Manitoba` },
    { value: $localize`:@@List_Provinces_NewBrunswick:New Brunswick`, selectedText: $localize`:@@List_Provinces_NewBrunswick:New Brunswick`, dropdownText: $localize`:@@List_Provinces_NewBrunswick:New Brunswick` },
    { value: $localize`:@@List_Provinces_NewfoundlandandLabrador:Newfoundland and Labrador`, selectedText: $localize`:@@List_Provinces_NewfoundlandandLabrador:Newfoundland and Labrador`, dropdownText: $localize`:@@List_Provinces_NewfoundlandandLabrador:Newfoundland and Labrador` },
    { value: $localize`:@@List_Provinces_NorthwestTerritories:Northwest Territories`, selectedText: $localize`:@@List_Provinces_NorthwestTerritories:Northwest Territories`, dropdownText: $localize`:@@List_Provinces_NorthwestTerritories:Northwest Territories` },
    { value: $localize`:@@List_Provinces_NovaScotia:Nova Scotia`, selectedText: $localize`:@@List_Provinces_NovaScotia:Nova Scotia`, dropdownText: $localize`:@@List_Provinces_NovaScotia:Nova Scotia` },
    { value: $localize`:@@List_Provinces_Nunavut:Nunavut`, selectedText: $localize`:@@List_Provinces_Nunavut:Nunavut`, dropdownText: $localize`:@@List_Provinces_Nunavut:Nunavut` },
    { value: $localize`:@@List_Provinces_Ontario:Ontario`, selectedText: $localize`:@@List_Provinces_Ontario:Ontario`, dropdownText: $localize`:@@List_Provinces_Ontario:Ontario` },
    { value: $localize`:@@List_Provinces_PrinceEdwardIsland:Prince Edward Island`, selectedText: $localize`:@@List_Provinces_PrinceEdwardIsland:Prince Edward Island`, dropdownText: $localize`:@@List_Provinces_PrinceEdwardIsland:Prince Edward Island` },
    { value: $localize`:@@List_Provinces_Quebec:Quebec`, selectedText: $localize`:@@List_Provinces_Quebec:Quebec`, dropdownText: $localize`:@@List_Provinces_Quebec:Quebec` },
    { value: $localize`:@@List_Provinces_Saskatchewan:Saskatchewan`, selectedText: $localize`:@@List_Provinces_Saskatchewan:Saskatchewan`, dropdownText: $localize`:@@List_Provinces_Saskatchewan:Saskatchewan` },
    { value: $localize`:@@List_Provinces_Yukon:Yukon`, selectedText: $localize`:@@List_Provinces_Yukon:Yukon`, dropdownText: $localize`:@@List_Provinces_Yukon:Yukon` }
  ],

  statesList: [
    { value: $localize`:@@:Alabama`, selectedText: $localize`:@@:Alabama`, dropdownText: $localize`:@@:Alabama` },
    { value: $localize`:@@:Alaska`, selectedText: $localize`:@@:Alaska`, dropdownText: $localize`:@@:Alaska` },
    { value: $localize`:@@:Arizona`, selectedText: $localize`:@@:Arizona`, dropdownText: $localize`:@@:Arizona` },
    { value: $localize`:@@:Arkansas`, selectedText: $localize`:@@:Arkansas`, dropdownText: $localize`:@@:Arkansas` },
    { value: $localize`:@@:California`, selectedText: $localize`:@@:California`, dropdownText: $localize`:@@:California` },
    { value: $localize`:@@:Colorado`, selectedText: $localize`:@@:Colorado`, dropdownText: $localize`:@@:Colorado` },
    { value: $localize`:@@:Connecticut`, selectedText: $localize`:@@:Connecticut`, dropdownText: $localize`:@@:Connecticut` },
    { value: $localize`:@@:Delaware`, selectedText: $localize`:@@:Delaware`, dropdownText: $localize`:@@:Delaware` },
    { value: $localize`:@@:Florida`, selectedText: $localize`:@@:Florida`, dropdownText: $localize`:@@:Florida` },
    { value: $localize`:@@:Georgia`, selectedText: $localize`:@@:Georgia`, dropdownText: $localize`:@@:Georgia` },
    { value: $localize`:@@:Hawaii`, selectedText: $localize`:@@:Hawaii`, dropdownText: $localize`:@@:Hawaii` },
    { value: $localize`:@@:Idaho`, selectedText: $localize`:@@:Idaho`, dropdownText: $localize`:@@:Idaho` },
    { value: $localize`:@@:Illinois`, selectedText: $localize`:@@:Illinois`, dropdownText: $localize`:@@:Illinois` },
    { value: $localize`:@@:Indiana`, selectedText: $localize`:@@:Indiana`, dropdownText: $localize`:@@:Indiana` },
    { value: $localize`:@@:Iowa`, selectedText: $localize`:@@:Iowa`, dropdownText: $localize`:@@:Iowa` },
    { value: $localize`:@@:Kansas`, selectedText: $localize`:@@:Kansas`, dropdownText: $localize`:@@:Kansas` },
    { value: $localize`:@@:Kentucky`, selectedText: $localize`:@@:Kentucky`, dropdownText: $localize`:@@:Kentucky` },
    { value: $localize`:@@:Louisiana`, selectedText: $localize`:@@:Louisiana`, dropdownText: $localize`:@@:Louisiana` },
    { value: $localize`:@@:Maine`, selectedText: $localize`:@@:Maine`, dropdownText: $localize`:@@:Maine` },
    { value: $localize`:@@:Maryland`, selectedText: $localize`:@@:Maryland`, dropdownText: $localize`:@@:Maryland` },
    { value: $localize`:@@:Massachusetts`, selectedText: $localize`:@@:Massachusetts`, dropdownText: $localize`:@@:Massachusetts` },
    { value: $localize`:@@:Michigan`, selectedText: $localize`:@@:Michigan`, dropdownText: $localize`:@@:Michigan` },
    { value: $localize`:@@:Minnesota`, selectedText: $localize`:@@:Minnesota`, dropdownText: $localize`:@@:Minnesota` },
    { value: $localize`:@@:Mississippi`, selectedText: $localize`:@@:Mississippi`, dropdownText: $localize`:@@:Mississippi` },
    { value: $localize`:@@:Missouri`, selectedText: $localize`:@@:Missouri`, dropdownText: $localize`:@@:Missouri` },
    { value: $localize`:@@:Montana`, selectedText: $localize`:@@:Montana`, dropdownText: $localize`:@@:Montana` },
    { value: $localize`:@@:Nebraska`, selectedText: $localize`:@@:Nebraska`, dropdownText: $localize`:@@:Nebraska` },
    { value: $localize`:@@:Nevada`, selectedText: $localize`:@@:Nevada`, dropdownText: $localize`:@@:Nevada` },
    { value: $localize`:@@:New Hampshire`, selectedText: $localize`:@@:New Hampshire`, dropdownText: $localize`:@@:New Hampshire` },
    { value: $localize`:@@:New Jersey`, selectedText: $localize`:@@:New Jersey`, dropdownText: $localize`:@@:New Jersey` },
    { value: $localize`:@@:New Mexico`, selectedText: $localize`:@@:New Mexico`, dropdownText: $localize`:@@:New Mexico` },
    { value: $localize`:@@:New York`, selectedText: $localize`:@@:New York`, dropdownText: $localize`:@@:New York` },
    { value: $localize`:@@:North Carolina`, selectedText: $localize`:@@:North Carolina`, dropdownText: $localize`:@@:North Carolina` },
    { value: $localize`:@@:North Dakota`, selectedText: $localize`:@@:North Dakota`, dropdownText: $localize`:@@:North Dakota` },
    { value: $localize`:@@:Ohio`, selectedText: $localize`:@@:Ohio`, dropdownText: $localize`:@@:Ohio` },
    { value: $localize`:@@:Oklahoma`, selectedText: $localize`:@@:Oklahoma`, dropdownText: $localize`:@@:Oklahoma` },
    { value: $localize`:@@:Oregon`, selectedText: $localize`:@@:Oregon`, dropdownText: $localize`:@@:Oregon` },
    { value: $localize`:@@:Pennsylvania`, selectedText: $localize`:@@:Pennsylvania`, dropdownText: $localize`:@@:Pennsylvania` },
    { value: $localize`:@@:Rhode Island`, selectedText: $localize`:@@:Rhode Island`, dropdownText: $localize`:@@:Rhode Island` },
    { value: $localize`:@@:South Carolina`, selectedText: $localize`:@@:South Carolina`, dropdownText: $localize`:@@:South Carolina` },
    { value: $localize`:@@:South Dakota`, selectedText: $localize`:@@:South Dakota`, dropdownText: $localize`:@@:South Dakota` },
    { value: $localize`:@@:Tennessee`, selectedText: $localize`:@@:Tennessee`, dropdownText: $localize`:@@:Tennessee` },
    { value: $localize`:@@:Texas`, selectedText: $localize`:@@:Texas`, dropdownText: $localize`:@@:Texas` },
    { value: $localize`:@@:Utah`, selectedText: $localize`:@@:Utah`, dropdownText: $localize`:@@:Utah` },
    { value: $localize`:@@:Vermont`, selectedText: $localize`:@@:Vermont`, dropdownText: $localize`:@@:Vermont` },
    { value: $localize`:@@:Virginia`, selectedText: $localize`:@@:Virginia`, dropdownText: $localize`:@@:Virginia` },
    { value: $localize`:@@:Washington`, selectedText: $localize`:@@:Washington`, dropdownText: $localize`:@@:Washington` },
    { value: $localize`:@@:West Virginia`, selectedText: $localize`:@@:West Virginia`, dropdownText: $localize`:@@:West Virginia` },
    { value: $localize`:@@:Wisconsin`, selectedText: $localize`:@@:Wisconsin`, dropdownText: $localize`:@@:Wisconsin` },
    { value: $localize`:@@:Wyoming`, selectedText: $localize`:@@:Wyoming`, dropdownText: $localize`:@@:Wyoming` }
  ],

  countryList: [
    { value: $localize`:@@List_Countries_Canada:Canada`, selectedText: $localize`:@@List_Countries_Canada:Canada`, dropdownText: $localize`:@@List_Countries_Canada:Canada` },
    { value: $localize`:@@List_Countries_USA:USA`, selectedText: $localize`:@@List_Countries_USA:USA`, dropdownText: $localize`:@@List_Countries_USA:USA` }
  ],

  genderList: [
    { value: $localize`:@@:Female`, selectedText: $localize`:@@:Female`, dropdownText: $localize`:@@:Female` },
    { value: $localize`:@@:Male`, selectedText: $localize`:@@:Male`, dropdownText: $localize`:@@:Male` },
    { value: $localize`:@@:X`, selectedText: $localize`:@@:X`, dropdownText: $localize`:@@:X` }
  ],

  maritalList: [
    { value: $localize`:@@:Single`, selectedText: $localize`:@@:Single`, dropdownText: $localize`:@@:Single` },
    { value: $localize`:@@:Married`, selectedText: $localize`:@@:Married`, dropdownText: $localize`:@@:Married` },
    { value: $localize`:@@:Common-law`, selectedText: $localize`:@@:Common-law`, dropdownText: $localize`:@@:Common-law` },
    { value: $localize`:@@:Separated`, selectedText: $localize`:@@:Separated`, dropdownText: $localize`:@@:Separated` },
    { value: $localize`:@@:Divorced`, selectedText: $localize`:@@:Divorced`, dropdownText: $localize`:@@:Divorced` }
  ],

  dateSelectOptionsList: [
    { value: $localize`:@@:All Time`, selectedText: $localize`:@@:All Time` },
    { value: $localize`:@@:Month`, selectedText: $localize`:@@:Month` },
    { value: $localize`:@@:6 Months`, selectedText: $localize`:@@:6 Months` },
    { value: $localize`:@@:Year`, selectedText: $localize`:@@:Year` }
  ],
  
  defaultUserImage: 'assets/images/users/user-dummy-img.jpg',
  defaultNoSignatureImage: 'assets/images/NoSignature.png',
  defaultMyfileNameImage: 'myfile_border.jpg',
  defaultDate: "00/00/0000",

  viewableExtensions: [
    ".pdf",
    ".png",
    ".jpg",
  ],

  colorHexCodes: {
    green: `#13c56b`,
    red: `#ed5e5e`,
    orange: `#f1963b`,
    purple: `#865ce2`,
    blue: `#33A6FF`,
  },

  StatusCode: true,


  authRedirectUrls: {
    userSignUp: '/auth/register',
    userSignIn: '/auth/login',
    default: '/',
    clientSignUp: '/auth/client-register',
    clientSignIn: '/auth/client-login',
  },

}


export enum dateSelectOptionsList {
  allTime = `All Time`,
  exactDate = `Exact Date`,
  week = `Week`,
  month = `Month`,
  sixMonths = `6 Months`,
  year = `Year`,
}